import type { FunctionComponent } from "react";
import { Button } from "@kanda-libs/ks-design-library";
import CompanyDeclineModal from "components/company/CompanyDeclineModal";

export interface CompanyDeclineButtonProps {
  showDeclineModal: () => void;
  isSubmitting: boolean;
}

const CompanyDeclineButton: FunctionComponent<CompanyDeclineButtonProps> =
  function ({ showDeclineModal, isSubmitting }) {
    return (
      <>
        <Button.Text
          id="decline-company"
          onClick={showDeclineModal}
          label="Decline company"
          size={40}
          className="mb-6"
          disabled={isSubmitting}
        />
        <CompanyDeclineModal />
      </>
    );
  };

export default CompanyDeclineButton;
